module.exports = __webpack_public_path__ + "img/bg-tentang.4eb9d833.webp";